import { PREV_YEAR_PREFIX } from 'partner360/features/competitorsSob/constants'
import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

type TQuarter = 'Q1' | 'Q2' | 'Q3' | 'Q4'

export const mapJustificationMessagesFieldToSobCompetitorField = (
  key: string
): keyof ISobCompetitor | null => {
  const quarter = ['Q1', 'Q2', 'Q3', 'Q4'].find((q) => key.includes(q)) as TQuarter | undefined

  if (quarter) {
    if (key.startsWith(PREV_YEAR_PREFIX)) {
      return `PrevJustificationActual${quarter}` as keyof ISobCompetitor
    }
    return `JustificationActual${quarter}` as keyof ISobCompetitor
  }

  return null
}
